export const GET_EVENTS = "GET_EVENTS";
export const FETCH_EVENTS = "FETCH_EVENTS";
export const SET_EVENTS = "SET_EVENTS";
